import styled from 'styled-components';
import { BasketMandatoryFeesStyled } from '../BasketMandatoryFeesStyled';
import { rem } from 'polished';

export const BasketMandatoryFeesDetailsOV = styled(BasketMandatoryFeesStyled)``;